import { Hero } from '../components/home/Hero';
import { Categories } from '../components/home/Categories';
import { FeaturedArtists } from '../components/home/FeaturedArtists';
import { SkipSearchForm } from '../components/SkipSearchForm';
import { BookingJourney } from '../components/home/BookingJourney';
import { MuaCta } from '../components/home/MuaCta';

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Categories />
      <FeaturedArtists />
      <section className="bg-white" data-testid="skip-search-section">
        <SkipSearchForm variant="cream" />
      </section>
      <BookingJourney />
      <MuaCta />
    </div>
  );
}
